import "@/styles/globals.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/components/theme-provider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { ConfirmHost } from "@/components/confirm";
import { ApiError } from "@/api/errors";
import { App } from "./app";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (count, err) => {
        // Never retry auth or validation failures; back off on rate limits.
        if (err instanceof ApiError && [400, 401, 402, 403, 404].includes(err.status)) return false;
        return count < 2;
      },
    },
  },
});

// A data router (not <BrowserRouter>) so screens with unsaved work can
// use `useBlocker`, which also catches the browser's Back button. The
// app keeps its own <Routes> tree underneath.
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          <RouterProvider router={router} />
          <Toaster position="bottom-right" />
          <ConfirmHost />
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
